import React from 'react';

import { 
    Modal,
    Button,
    Spinner,
    CloseButton,
    Row,
    Col,
} from "react-bootstrap-v5";

  
const CustomDialog = props => {
    const [isLoading, setIsLoading] = React.useState(((props.isLoading === false) || (props.isLoading === true)) ? props.isLoading : false);
    const [show, setShow] = React.useState(((props.show === false) || (props.show === true)) ? props.show : false);
    

    React.useEffect(() => {
        setIsLoading(((props.isLoading === false) || (props.isLoading === true)) ? props.isLoading : false);
    }, [props.isLoading]);

    React.useEffect(() => {
        setShow(((props.show === false) || (props.show === true)) ? props.show : false);
    }, [props.show]);

    
    return <Modal
        show={show}
        onHide={() => {
            if(props.onCancel){
                props.onCancel();
            }
        }}
        centered
        backdrop="static"
        size={props.size ? props.size : 'md'}
        fullscreen={((props.fullscreen === false) || (props.fullscreen === true)) ? props.fullscreen : false}
        keyboard={((props.fullscreen === false) || (props.fullscreen === true)) ? props.fullscreen : false}
        enforceFocus={false}
    >
        <Modal.Header>
            <Row className={'align-items-center gx-0 w-100'}>
                {props.title && <Col xs={true}>
                    <Modal.Title>{props.title ? props.title : ''}</Modal.Title>
                </Col>}
                <Col xs={'auto'}>
                    <CloseButton
                        className={'rounded-2'}
                        onClick={() => {
                            if(props.onCancel){
                                props.onCancel();
                            }
                        }}
                    />
                </Col>
            </Row>
        </Modal.Header>
        {props.body && <Modal.Body>{props.body ? props.body : ''}</Modal.Body>}
        <Modal.Footer>
            {props.cancelText && <Button 
                type={'button'}
                variant={props.cancelVariant ? props.cancelVariant : 'secondary'}
                disabled={isLoading}
                onClick={() => {
                    if(props.onCancel){
                        props.onCancel();
                    }
                }}
            >
                {props.cancelText ? props.cancelText : 'Cancel'}
                {isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
            </Button>}
            {props.okText && <Button 
                type={'button'}
                variant={props.okVariant ? props.okVariant : 'primary'}
                disabled={isLoading}
                onClick={() => {
                    if(props.onOk){
                        props.onOk();
                    }
                }}
            >
                {props.okText ? props.okText : 'OK'}
                {isLoading ? <>&nbsp;<Spinner animation="border" size={'sm'} /></> : null}
            </Button>}
        </Modal.Footer>
    </Modal>
}


export default CustomDialog;
